import { render, staticRenderFns } from "./largeFeed1.vue?vue&type=template&id=d257952a&scoped=true"
import script from "./largeFeed1.vue?vue&type=script&lang=js"
export * from "./largeFeed1.vue?vue&type=script&lang=js"
import style0 from "./largeFeed1.vue?vue&type=style&index=0&id=d257952a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d257952a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d257952a')) {
      api.createRecord('d257952a', component.options)
    } else {
      api.reload('d257952a', component.options)
    }
    module.hot.accept("./largeFeed1.vue?vue&type=template&id=d257952a&scoped=true", function () {
      api.rerender('d257952a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeFeed1.vue"
export default component.exports